<template>
    <div
        :class="{ revealed: showCompletely }"
        class="discount-button"
        @mouseenter="showSome = true"
        @mouseleave="showSome = false"
    >
        <div class="discount-button-cta" @click="$emit('reveal')">Revelar desconto</div>
        <div class="discount-button-code">
            <span>{{ featuredDiscount.discount.name }}</span>
        </div>
    </div>
</template>

<script>
    import LoadingButton from '../common/LoadingButton';
    import Modal from '../common/container/Modal';
    import TextField from '@bit/chicorei.chicomponents.input.text-field';

    export default {
        name: 'DiscountButton',

        components: { LoadingButton, TextField, Modal },

        props: {
            featuredDiscount: Object,
        },

        data() {
            return {
                showSome: false,
                showCompletely: false,
            };
        },

        methods: {
            submit() {
                this.submitting = true;
            },
        },
    };
</script>
